import React from 'react';

const Toggle = ({ 
    label, 
    checked, 
    onChange, 
    disabled = false,
    size = 'default',
    variant = 'primary',
    className = '',
    style
}) => {

    const getVariantClass = () => {
        switch (variant) {
            case 'success':
                return 'form-check-input-success';
            case 'warning':
                return 'form-check-input-warning';
            case 'danger':
                return 'form-check-input-danger';
            case 'info':
                return 'form-check-input-info';
            default:
                return 'form-check-input-primary';
        }
    };

    return (
        <div style={style}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
            <input
                className={`form-check-input ${getVariantClass()}`}
                type="checkbox"
                role="switch"
                id={`toggle-${Math.random().toString(36).substr(2, 9)}`}
                checked={checked}
                onChange={onChange}
                disabled={disabled}
            />
            {label && (
                <label 
                    className="form-check-label" 
                    htmlFor={`toggle-${Math.random().toString(36).substr(2, 9)}`}
                    style={{ 
                        marginLeft: '8px',
                        fontSize: '18px',
                        fontWeight: '500',
                        color: 'grey',
                        cursor: disabled ? 'not-allowed' : 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent:'center',
                        marginTop: '2px'
                    }}
                >
                    {label}
                </label>
            )}
        </div>
        </div>
    );
};

export default Toggle;
